import React, { useEffect, useState } from "react";
import { Row, Col, FormGroup } from "reactstrap";

import { useFormik } from "formik";
import * as Yup from "yup";

import { useDispatch, useSelector } from "react-redux";
import { getItems } from "../../slices/Item/GetItem/thunk";
import { createPriceBook } from "../../slices/PriceBook/AddPriceBook/thunk";
import { updatePriceBook } from "../../slices/PriceBook/UpdatePriceBook/thunk";

import { LabelText } from "../Utils/Input";
import InputField from "../Utils/InputField";
import SelectField from "../Utils/SelectField";
import CommonButton from "../Utils/CommonButton";
import { Loader } from "../Utils/Loader";

function PriceBookForm({ closeModal, onSuccess, selectedItem }) {
  const dispatch = useDispatch();
  const { items } = useSelector((state) => state.GetItems || {});
  const [loading, setLoading] = useState(false);
  const currencySymbol = localStorage.getItem("currencySymbol");

  useEffect(() => {
    dispatch(getItems(10000, 1));
  }, [dispatch]);

  const itemOptions =
    (items?.items || []).map((item) => ({
      label: item.itemname,
      value: item.itemid,
      sku: item.sku,
      itemname: item.itemname,
    })) || [];

  const formik = useFormik({
    enableReinitialize: true,

    initialValues: {
      item: selectedItem
        ? {
            label: selectedItem.item,
            value: selectedItem.itemid,
            sku: selectedItem.sku,
            itemname: selectedItem.item,
          }
        : null,

      unitprice: selectedItem?.cost || "",
      //   listprice: selectedItem?.listprice || "",
    },

    validationSchema: Yup.object({
      item: Yup.object().required("Required"),
      unitprice: Yup.number().required("Required"),
      //   listprice: Yup.number().required("Required"),
    }),

    onSubmit: (values) => {
      const payload = {
        sku: values.item.sku,
        itemid: values.item.value,
        itemname: values.item.itemname,
        unitprice: Number(values.unitprice),
        // listprice: Number(values.listprice),
      };

      if (selectedItem) {
        dispatch(
          updatePriceBook(payload, values.item.value, setLoading, () => {
            onSuccess?.();
            closeModal?.();
          }),
        );
      } else {
        dispatch(
          createPriceBook(payload, setLoading, () => {
            onSuccess?.();
            closeModal?.();
          }),
        );
      }
    },
  });

  const { values, errors, touched, handleChange, setFieldValue, handleSubmit } =
    formik;

  return (
    <>
      {loading && <Loader />}
      <form onSubmit={handleSubmit}>
        <Row className="gy-1">
          <Col md={12}>
            <FormGroup>
              <LabelText
                htmlFor={"item"}
                className={"text-danger"}
                displayText={"Product"}
                important={"*"}
              />

              <SelectField
                value={values.item}
                placeholder="Select Product"
                options={itemOptions}
                handleChange={(val) => setFieldValue("item", val)}
                isRVStyle={true}
                isDisabled={!!selectedItem}
                className={touched.item && errors.item ? "error-input" : ""}
              />
            </FormGroup>
          </Col>

          {/* UNIT PRICE */}
          <Col md={12}>
            <FormGroup>
              <LabelText
                htmlFor={"unitprice"}
                displayText={`Unit Price (${currencySymbol})`}
                className={"text-danger"}
                important={"*"}
              />

              <InputField
                name="unitprice"
                type="number"
                placeholder="Enter Unit Price"
                value={values.unitprice}
                handleChange={handleChange}
                invalid={touched.unitprice && errors.unitprice}
              />
            </FormGroup>
          </Col>

          {/* LIST PRICE */}
          {/* <Col md={12}>
          <FormGroup>
            <LabelText
              htmlFor={"listprice"}
              className={"text-danger"}
              displayText={"List Price"}
              important={"*"}
            />

            <InputField
              name="listprice"
              type="number"
              placeholder="Enter List Price"
              value={values.listprice}
              handleChange={handleChange}
              invalid={touched.listprice && errors.listprice}
            />
          </FormGroup>
        </Col> */}

          <div
            className="d-flex justify-content-center w-100 gap-2 flex-wrap pe-1 py-3"
            style={{
              position: "sticky",
              bottom: 0,
              backgroundColor: "#fff",
              borderTop: "1px solid #e9ebec",
              marginTop: "10px",
            }}
          >
            <div className="d-flex gap-2 justify-content-center">
              <CommonButton
                outline={true}
                className="btn-label rv-secondary-btn rounded-1 px-1 ps-4 py-1 w-100 w-md-auto text-nowrap"
                color={"main-color"}
                type={"button"}
                buttonAction={() => closeModal()}
                buttonText={"Cancel"}
                icon={
                  <i className="ri-close-fill label-icon secondary-label-icon align-middle fs-16 me-2"></i>
                }
                btnTxtClsName="px-2 ps-3 ms-2 me-1 fw-bold"
              />

              <CommonButton
                color={"main-color"}
                className="btn-label rv-primary-btn rounded-1 px-1 ps-4 py-1 w-100 w-md-auto text-nowrap"
                icon={
                  <i className="ri-checkbox-circle-line label-icon align-middle fs-16 me-2"></i>
                }
                btnTxtClsName="px-2 ps-3 ms-2 me-1 fw-bold"
                type={"submit"}
                buttonText={"Submit"}
                disabled={loading}
              />
            </div>
          </div>
        </Row>
      </form>
    </>
  );
}

export default PriceBookForm;
